import { useEffect, useState } from "react";
import { Lock, Unlock, CheckCircle2, RotateCcw } from "lucide-react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../ui/input-otp";

const DEMO_OTP = "4821";

export const TokenDemo = ({ pricing }) => {
  const UNLOCK_FEE = pricing.mode === "free" ? 0 : pricing.unlock_fee;
  const START = pricing.wallet_options[0];
  const [wallet, setWallet] = useState(START);
  useEffect(() => { setWallet(START); }, [START]);
  const [unlocked, setUnlocked] = useState(false);
  const [otp, setOtp] = useState("");
  const joined = otp === DEMO_OTP;

  const unlock = () => { setUnlocked(true); setWallet((w) => w - UNLOCK_FEE); };
  const reset = () => { setUnlocked(false); setOtp(""); setWallet(START); };

  return (
    <div data-testid="token-demo" className="sticky top-28 border border-white/10 bg-[#1E293B]/60 p-6 backdrop-blur-xl sm:p-8">
      <div className="flex items-center justify-between">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-orange-400">Interactive demo</p>
        <button onClick={reset} data-testid="token-demo-reset" className="flex items-center gap-1 text-xs text-slate-400 hover:text-white"><RotateCcw className="h-3 w-3" />Reset</button>
      </div>
      <div className={`mt-5 flex items-center justify-between border border-white/10 bg-[#0B1120] px-4 py-3 ${UNLOCK_FEE ? "" : "hidden"}`}>
        <span className="text-sm text-slate-400">Employer wallet</span>
        <span data-testid="token-demo-wallet" className="font-mono text-lg font-bold text-white">₹{wallet.toLocaleString("en-IN")}</span>
      </div>
      <div className="mt-4 border border-white/10 bg-[#0B1120] p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="font-semibold text-white">R. Pradhan · Security Guard</p>
            <p className="mt-1 text-sm text-slate-400">Age 29 · 175 cm · Ex-Serviceman · Balangir</p>
          </div>
          <span className="border border-sky-500/40 px-2 py-0.5 text-[11px] text-sky-300">Security</span>
        </div>
        <p data-testid="token-demo-contact" className="mt-4 flex items-center gap-2 font-mono text-slate-300">
          {unlocked ? <Unlock className="h-4 w-4 text-emerald-400" /> : <Lock className="h-4 w-4 text-slate-500" />}
          {unlocked ? "+91 98XXX 4X210 · Token #JT-0193" : "+91 ●●●●● ●●●●●"}
        </p>
        {!unlocked ? (
          <button onClick={unlock} data-testid="token-demo-unlock-button" className="mt-5 w-full bg-orange-500 py-3 text-sm font-semibold text-white transition-colors hover:bg-orange-600">
            Request Contact / Issue Job Token <span className="whitespace-nowrap">({UNLOCK_FEE ? `−₹${UNLOCK_FEE.toLocaleString("en-IN")}` : "Free"})</span>
          </button>
        ) : (
          <div className="mt-5 border-t border-white/10 pt-5">
            <p className="text-sm text-slate-400">Employee reports to site and shares Joining OTP. Try <span className="font-mono text-orange-400">{DEMO_OTP}</span></p>
            <InputOTP maxLength={4} value={otp} onChange={setOtp} data-testid="token-demo-otp-input" containerClassName="mt-3">
              <InputOTPGroup>
                {[0, 1, 2, 3].map((i) => <InputOTPSlot key={i} index={i} className="h-12 w-12 border-white/15 font-mono text-lg text-white" />)}
              </InputOTPGroup>
            </InputOTP>
            {joined && (
              <p data-testid="token-demo-joined" className="mt-4 flex items-center gap-2 text-sm text-emerald-400">
                <CheckCircle2 className="h-4 w-4" /> Placement verified — added to monthly commission ledger
              </p>
            )}
          </div>
        )}
      </div>
      <p className="mt-4 text-xs leading-relaxed text-slate-500">Demo only. Figures and the unlock fee shown are illustrative; actual rates are agreed per contract.</p>
    </div>
  );
};
